import React from "react"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import styles from "@/components/ProductDetail/v3/ServiceAvailability/index.module.scss"
import toolsIcon from "@/public/icons/brand-installation.svg"
import { NumericFormat } from "react-number-format"

const ServiceAvailability = ({
  i18n = {},
  config = {},
  isChecked,
  currencySign = "₹",
  setIsChecked,
  installationData = {},
}) => {
  const { legalPageData } = config
  const { name, price, mrpPrice } = installationData
  let exactPrice = (price / 100).toFixed(2)
  const exactMRPPrice = (mrpPrice / 100).toFixed(2)
  if (isNaN(exactPrice)) {
    exactPrice = exactMRPPrice
  }

  return (
    <div className={styles.pdpServiceAvailabilityWrapper}>
      <div className="pdp-service-available">
        <div className="avilable-icon">
          <img src={toolsIcon.src} alt="Tools" />
        </div>
        <div className="available-content">
          <h5>{name}</h5>
          <div className="installtion-div">
            <span>{i18n.installServiceAvailableDesc({ exactPrice })}</span>
            <a href={legalPageData.map?.termsOfService} className="tc">
              {i18n.tc}
            </a>
          </div>
          <div className="terms --mobile">
            <p className="price">
              <NumericFormat
                value={exactPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
              />
            </p>
            {exactMRPPrice !== exactPrice && (
              <div className="installtion-service">
                <div className="mrp">{i18n.mrp}</div>
                <p className="price price-discounted">
                  <NumericFormat
                    value={exactMRPPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandsGroupStyle={"lakh"}
                  />
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="available-price">
          <div className="terms">
            <p className="price">
              <NumericFormat
                value={exactPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
              />
            </p>
            {exactMRPPrice !== exactPrice && (
              <div className="installtion-service">
                <div className="mrp">{i18n.mrp}</div>
                <p className="price price-discounted">
                  <NumericFormat
                    value={exactMRPPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandsGroupStyle={"lakh"}
                  />
                </p>
              </div>
            )}
          </div>
          <Checkbox
            checked={isChecked}
            onChange={e => setIsChecked(e.target.checked)}
          />
        </div>
      </div>
    </div>
  )
}
export default ServiceAvailability
